import React from 'react';
import classes from './navigationitems.module.css';
import NavigationItem from '../NavigationItem/NavigationItem';


const navigationItems = (props) => (
 <ul className={classes.NavigationItems}>
     <NavigationItem link="/" active> Burger Builder </NavigationItem>
     {props.isAuthenticated ? <NavigationItem link="/orders" active> Orders </NavigationItem> : null}
     {props.isAuthenticated ?
     <NavigationItem link="/logout" active> Log Out </NavigationItem>
     : 
     <NavigationItem link="/auth" active> Authenticate </NavigationItem>
    }  
 </ul>
);

export default navigationItems;